<template>
  <v-card flat class="p-8" :loading="loading">
    <date-picker
      label="تاریخ تراکنش"
      v-model="search.date"
      format="YYYY-MM-DD"
      display-format="jYYYY-jMM-jDD"
    />
    <mixed-table
      :data="data"
      :columns="columns"
      :fetch-data="getDataForTable"
      :reload-table="reloadTable"
      :tbProps="tableProps"
    />
  </v-card>
</template>

<script>
import axios from "axios";
import MixedTable from "@/components/Table/MixedTable";
import { debounce } from "@/custom";
import Meta from "@/view/pages/WalletHistory/Meta";
import { dataTableProps } from "@/main";

export default {
  name: "WalletHistory",
  components: { MixedTable },
  props: {
    search: {
      required: true,
      type: Object,
    },
  },
  data() {
    return {
      coreAxios: axios.create({
        baseURL: this.$sarveLand,
        timeout: 30_000,
        headers: {
          Authorization: "Bearer " + localStorage.getItem("id_token"),
          Accept: "application/json",
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json",
        },
      }),
      url: "/api/admin/wallet/walletMonitoring",
      data: {},
      columns: [
        {
          label: "ردیف",
          transform: (val) => {
            let row = this.data.current_page - 1;
            row = row * this.data.per_page;
            return row + val.row + 1;
          },
          orderable: true,
        },
        {
          label: "شناسه",
          name: "id",
          orderable: true,
        },
        {
          label: "مبلغ (﷼)",
          name: "amount",
        },
        {
          label: "تاریخ",
          transform(val) {
            return this.$options.filters.longDate(val.data.created_at);
          },
        },
        {
          label: "توضیحات تکمیلی",
          name: "description",
        },
        {
          name: "admin_type",
          label: "نوع تراکنش",
          component: Meta,
          meta: {
            type: "adminType",
          },
        },
        {
          name: "confirmed",
          label: "وضعیت",
          transform: (value) => {
            return value.data.confirmed === true
              ? `<span class="badge-pill badge badge-info">تایید شده</span>`
              : `<span class="badge-pill badge badge-danger">تایید نشده</span>`;
          },
        },
        {
          name: "comment",
          label: "توضیح",
          component: Meta,
          meta: {
            type: "comment",
          },
        },
        {
          name: "service",
          label: "نام سرویس",
          component: Meta,
          meta: {
            type: "service",
          },
        },
        {
          name: "remainMoney",
          label: "مانده موجودی",
          transform: ({ data }) => {
            return this.persian(this.$options.filters.rial(data.remainMoney));
          },
        },
      ],
      tableProps: dataTableProps.tableProps,
    };
  },
  methods: {
    getDataForTable(url = this.url, query = this.tableProps) {
      this.loading = true;
      this.coreAxios
        .get(url, {
          params: {
            ...query,
            user_id: this.search.user,
            date: this.search.date,
          },
        })
        .then((response) => {
          this.data = response.data.data;
          this.loading = false;
        })
        .catch((reason) => {
          console.log(reason);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    reloadTable(tableProps) {
      debounce(() => {
        this.tableProps.page = this.data.current_page;
        this.getDataForTable(this.url, tableProps);
      }, 1000);
    },
  },
  watch: {
    search: {
      deep: true,
      handler(val) {
        this.getDataForTable(this.url, {
          ...this.tableProps,
          user_id: val.user,
          created_at: val.date,
        });
      },
    },
  },
};
</script>

<style scoped></style>
